import Colors from "../assets/constants/Colors";
import { Spacers } from "../assets/constants/Spacers";
import HomeHero from "../components/HomeHero";
import styled from "../styled-components";

const { pageContent } = Spacers;

const Home = () => {

  return (
    <PageContainer>
      <PageContentContainer>
        
        <PageSectionContainer>
          <HomeHero/>
        </PageSectionContainer>

      </PageContentContainer>
    </PageContainer>
  );
};
export default Home;

export const cardStyles = {
  alignItems: "center",
  backgroundColor: Colors.surfaceForeground,
  borderColor: Colors.surfaceForegroundBorder,
  marginBottom: "15px",
};

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
  overflow: visible;
`;